import NoAnomalyFound from '@cp/src/assets/icons/NoAnomalyFound';
import { Typography } from '@navi/web-ui/lib/primitives';

const NoResultsFound = () => {
  return (
    <div className="flex flex-col justify-center items-center h-full">
      <NoAnomalyFound />
      <Typography color="var(--grayscale-2)" variant="p3" className="mt-8 font-medium">
        No results found!
      </Typography>
    </div>
  );
};

export default NoResultsFound;
